import { render, staticRenderFns } from "./SamModal.vue?vue&type=template&id=58663346&scoped=true&shadow"
import script from "./SamModal.vue?vue&type=script&lang=js&shadow"
export * from "./SamModal.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamModal.vue?vue&type=style&index=0&id=58663346&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "58663346",
  null
  ,true
)

export default component.exports